__turbopack_context__.v({
  "clearFilters": "CCrmProjectManagement-module___ZM44a__clearFilters",
  "deleteWarning": "CCrmProjectManagement-module___ZM44a__deleteWarning",
  "detailGrid": "CCrmProjectManagement-module___ZM44a__detailGrid",
  "detailItem": "CCrmProjectManagement-module___ZM44a__detailItem",
  "detailNote": "CCrmProjectManagement-module___ZM44a__detailNote",
  "detailSection": "CCrmProjectManagement-module___ZM44a__detailSection",
  "detailSectionTitle": "CCrmProjectManagement-module___ZM44a__detailSectionTitle",
  "domain": "CCrmProjectManagement-module___ZM44a__domain",
  "entryText": "CCrmProjectManagement-module___ZM44a__entryText",
  "expiredAgo": "CCrmProjectManagement-module___ZM44a__expiredAgo",
  "filterField": "CCrmProjectManagement-module___ZM44a__filterField",
  "filters": "CCrmProjectManagement-module___ZM44a__filters",
  "hoursCell": "CCrmProjectManagement-module___ZM44a__hoursCell",
  "name": "CCrmProjectManagement-module___ZM44a__name",
  "nameCell": "CCrmProjectManagement-module___ZM44a__nameCell",
  "note": "CCrmProjectManagement-module___ZM44a__note",
  "nowrap": "CCrmProjectManagement-module___ZM44a__nowrap",
  "pageButton": "CCrmProjectManagement-module___ZM44a__pageButton",
  "pageInfo": "CCrmProjectManagement-module___ZM44a__pageInfo",
  "pagination": "CCrmProjectManagement-module___ZM44a__pagination",
  "reasonItem": "CCrmProjectManagement-module___ZM44a__reasonItem",
  "reasonList": "CCrmProjectManagement-module___ZM44a__reasonList",
  "renewBtn": "CCrmProjectManagement-module___ZM44a__renewBtn",
  "renewIcon": "CCrmProjectManagement-module___ZM44a__renewIcon",
  "root": "CCrmProjectManagement-module___ZM44a__root",
  "rowActions": "CCrmProjectManagement-module___ZM44a__rowActions",
  "rowButton": "CCrmProjectManagement-module___ZM44a__rowButton",
  "rowNr": "CCrmProjectManagement-module___ZM44a__rowNr",
  "searchWrap": "CCrmProjectManagement-module___ZM44a__searchWrap",
  "sortIcon": "CCrmProjectManagement-module___ZM44a__sortIcon",
  "sortIconActive": "CCrmProjectManagement-module___ZM44a__sortIconActive",
  "stateActive": "CCrmProjectManagement-module___ZM44a__stateActive",
  "stateEnded": "CCrmProjectManagement-module___ZM44a__stateEnded",
  "stateReceived": "CCrmProjectManagement-module___ZM44a__stateReceived",
  "stateStopped": "CCrmProjectManagement-module___ZM44a__stateStopped",
  "summaryValue": "CCrmProjectManagement-module___ZM44a__summaryValue",
  "table": "CCrmProjectManagement-module___ZM44a__table",
  "tableWrap": "CCrmProjectManagement-module___ZM44a__tableWrap",
  "thInner": "CCrmProjectManagement-module___ZM44a__thInner",
  "thSortable": "CCrmProjectManagement-module___ZM44a__thSortable",
  "toolbar": "CCrmProjectManagement-module___ZM44a__toolbar",
  "truncatedHint": "CCrmProjectManagement-module___ZM44a__truncatedHint",
});
